<template>
    <div class="sidebar">
        <div class="app-logo" :class="isCollapse ? '' : 'isOpend'">
            <img :src="companyLogo.company_icon" width="120" height="28" v-if="!isCollapse" alt="LOGO">
            <img :src="companyLogo.company_small_icon" width="33px" height="28px" v-if="isCollapse" alt="LOGO">
        </div>
        <div class="menu-toggle" @click="closeAllTab" v-if="!isCollapse">
            <i class="el-icon-circle-plus-outline" v-if="!tabOpends"></i>
            <i class="el-icon-remove-outline" v-else></i>
        </div>
        <el-menu :default-active="currentMenu"
                 class="sidebar-menu"
                 show-timeout="0"
                 hide-timeout="0"
                 background-color="#304156"
                 text-color="#fff"
                 router
                 :default-openeds="openeds"
                 :unique-opened="false"
                 @open="handleOpen"
                 @close="handleClose"
                 ref="navMenu"
                 :collapse="isCollapse">
            <template v-for="(menuItem, i) in menu">
                <el-menu-item :index="menuItem.path"
                              :class="(currentMenu == '/index-panel' && menuItem.path == '/index') ? 'is-active' : ''"
                              v-if="menuItem.children.length === 0 || menuItem.meta.hideChildMenu">
                    <svg-icon :icon-class="menuItem.meta.icon"></svg-icon>
                    <span slot="title">{{menuItem.meta.title}}</span>
                </el-menu-item>
                <el-submenu :index="menuItem.path" v-else>
                    <template slot="title">
                        <svg-icon :icon-class="menuItem.meta.icon"></svg-icon>
                        <span slot="title">{{menuItem.meta.title}}</span>
                    </template>
                    <el-menu-item-group v-for="( chileItem, index ) in menuItem.children" :key="'childItem'+index">
                        <el-menu-item :index="chileItem.path">{{chileItem.meta.title}}</el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </template>
        </el-menu>
    </div>
</template>

<script>
    export default {
        name: 'sidebar',
        data() {
            return {
                subMenuActived: '',
                openeds: [],
                tabOpends: true,
            }
        },
        computed: {
            isCollapse() {
                let clapse =  this.$store.state.app.sidebar.clapse
                // this.openeds = []
                // this.$nextTick(() => {
                //     this.openeds = open
                // })
                if (!clapse) {
                    console.log(2)
                }
                return clapse
            },
            menu() {
                let routes = []
                if (this.$store.state.permission.addRoutes && this.$store.state.permission.addRoutes.length > 0) {
                    this.$store.state.permission.addRoutes.map((item, i) => {
                        if (item.name == 'layout') {

                            if(this.tabOpends) {
                                console.log('item====>',  item.children)
                                item.children.map(pathItem => {
                                    this.openeds.push(pathItem.path)
                                })
                            }


                            routes = item.children
                        }
                    })
                }
                return routes
            },
            currentMenu() {
                if (this.$route.matched.length > 3) {
                    return this.$route.matched[2].path
                } else {
                    return this.$route.path
                }

            },
            companyLogo() {
                return this.$store.state.user.logo
            }
        },
        methods: {
            closeAllTab(){
                console.log('this.openeds=', this.openeds)
                this.openeds = []
                this.tabOpends = !this.tabOpends
                this.$nextTick(() => {
                    console.log('this.openeds=', this.openeds)
                })
            },
            handleOpen(key, keyPath) {

            },
            handleClose(key, keyPath) {
                this.tabOpends = false
            },
        },
        mounted() {

        }
    }
</script>

<style lang="scss">
    .sidebar {
        // z-index: 1000;
        z-index: inherit;
        position: relative;
        .menu-toggle{
            position: fixed;
            top: 69px;
            left: 136px;
            /*background-color: #2e3339 ;*/
            z-index: 99;
            padding: 4px;
            cursor: pointer;
            font-size: 0px;
            i{
                font-size: 20px;
                color: #fff;
                font-weight: bold;
            }
        }
        .app-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            height: $headerHeight;
            line-height: $headerHeight;
            background-color: $mainColor;
            max-width: $sideBarWidth;
            padding: 0 10px;
            position: sticky;
            top: 0;
            z-index: 999;

            &.isOpend {
                width: $sideBarWidth;
            }

            .app-logo-img {
                width: 33px;
                margin-left: 10px;
            }

            .app-logo-title {
                flex: 1;
                padding-left: 10px;
            }

        }

        .sidebar-menu {
            @include calcHeight($headerHeight);

            &:not(.el-menu--collapse) {
                width: $sideBarWidth;
            }
            .el-menu{
                overflow: hidden!important;
            }
        }
    }

</style>
